import { render, staticRenderFns } from "./SLItemAdd.vue?vue&type=template&id=a04675f2&"
import script from "./SLItemAdd.vue?vue&type=script&lang=js&"
export * from "./SLItemAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports